import { useAppStore } from './appStore';

/* Points d'entrée des messages, utilisables hors composants (traitements métier). */

let nextId = 1;

/** Repère : les erreurs affichées après lui pourront être retirées ensemble. */
export const noticeMark = () => nextId;

/** Retire les bandeaux d'erreur affichés depuis le repère, devenus obsolètes. */
export function dismissErrorsSince(mark) {
  const { toasts, removeToast } = useAppStore.getState();
  toasts.filter((t) => t.kind === 'error' && t.id >= mark).forEach((t) => removeToast(t.id));
}

/** Bandeau : erreur par défaut ; erreur et information restent affichées, un succès disparaît seul. */
export function notify(message, kind = 'error') {
  const id = nextId++;
  useAppStore.getState().addToast({ id, message: String(message), kind });
  return id;
}

// Une seule boîte à la fois : une nouvelle demande annule celle restée ouverte.
function openDialog(dialog) {
  const { dialog: previous, setDialog } = useAppStore.getState();
  previous?.resolve(previous.kind === 'prompt' ? null : false);
  return new Promise((resolve) =>
    setDialog({
      ...dialog,
      resolve: (answer) => {
        useAppStore.getState().setDialog(null);
        resolve(answer);
      },
    }),
  );
}

/** Confirmation : true si l'utilisateur valide, false s'il annule. */
export function confirmAsk(
  message,
  {
    title = 'Confirmation',
    confirmLabel = 'Confirmer',
    cancelLabel = 'Annuler',
    danger = false,
  } = {},
) {
  return openDialog({ kind: 'confirm', message, title, confirmLabel, cancelLabel, danger });
}

/** Confirmation d'une suppression (bouton rouge « Supprimer »). */
export const confirmDelete = (message) =>
  confirmAsk(message, { title: 'Suppression', confirmLabel: 'Supprimer', danger: true });

/** Saisie d'un texte : la valeur saisie (sans espaces autour), ou null si annulé ou vide. */
export function promptAsk(
  message,
  { title = 'Saisie', confirmLabel = 'Valider', defaultValue = '' } = {},
) {
  return openDialog({ kind: 'prompt', message, title, confirmLabel, defaultValue });
}
